<template>
  <el-card class="fitness-store-edit">
    <div class="fitness-title">{{ $t('Setting.Store_information') }}</div>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="110px"
      v-loading="loading"
      label-suffix=":" >
      <el-form-item :label="$t('Store.Edit.store_name')" prop="name">
        <el-input v-model.trim="form.name"/>
      </el-form-item>
      <el-form-item :label="$t('Store.Edit.store_code')" prop="code">
        <el-input v-model.trim="form.code"/>
      </el-form-item>
      <el-form-item :label="$t('Store.Edit.store_phone')" prop="phone">
        <el-input v-model.trim="form.phone"/>
      </el-form-item>
      <el-row type="flex" class="row-bg" justify="start">
        <el-col :span="6">
          <el-form-item :label="$t('Client.address')">
            <el-select
              v-model="form.provinceId"
              :placeholder="$t('Store.Edit.select_province')"
              @change="handleProvinceChange"
              style="width:180px;margin-right:5px;" >
              <el-option
                v-for="item in this.district"
                :key="item.id"
                :value="item.id"
                :label="item.fullname" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label-width="0px">
            <el-select
              v-model="form.cityId"
              :placeholder="$t('Store.Edit.select_city')"
              @change="handleCityChange"
              style="width:180px;margin-right:5px;" >
              <el-option
                v-for="item in this.province.children"
                :key="item.id"
                :value="item.id"
                :label="item.fullname" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label-width="0px">
            <el-select v-model="form.districtId" :placeholder="$t('Store.Edit.select_area')">
              <el-option
                v-for="item in this.city.children"
                :key="item.id"
                :value="item.id"
                :label="item.fullname" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label-width="0px">
            <el-input v-model.trim="form.address" style="width:300px"/>
          </el-form-item>
        </el-col>
      </el-row>
      <template>
        <el-button type="primary" style="margin-left:105px" @click.prevent="placeSearch">{{ $t('Store.Edit.Adjust_location') }}</el-button>
      </template>
      <div id="container"></div>
      <div id="myPageTop" v-if="position" class="position-div">
        <table>
          <tr>
            <td>
              <input
                ref="input"
                id="tipinput"
                @keyup="keyUpSearch"
                :placeholder="$t('Store.Edit.import_keyword')"
                class="position-input" >
            </td>
          </tr>
        </table>
      </div>
      <el-form-item :label="$t('Store.Edit.store_longitude')" prop="longitude">
        {{form.longitude}}
      </el-form-item>
      <el-form-item :label="$t('Store.Edit.store_latitude')" prop="latitude">
        {{form.latitude}}
      </el-form-item>
      <el-form-item :label="$t('Store.Edit.email')" prop="email">
        <el-input v-model.trim="form.email"/>
      </el-form-item>
      <el-form-item :label="$t('Store.Edit.rank_weight')" prop="weight">
        <el-input v-model.trim.number="form.weight"/>
      </el-form-item>

      <el-form-item :label="$t('Store.Edit.operation_not')" prop="trial">
        <el-select v-model="form.trial" class="w-full" clearable>
          <el-option :label="$t('Common.yes')" :value="true"/>
          <el-option :label="$t('Common.no')" :value="false"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('Common.save') }}</el-button>
        <el-button @click="back">{{ $t('tooltip.back') }}</el-button>
      </el-form-item>
    </el-form>

  </el-card>
</template>
<script>
import { Switch, Row, Col, Dialog } from 'element-ui';

export default {
    components: {
        ElSwitch: Switch,
        ElRow: Row,
        ElCol: Col,
        ElDialog: Dialog,
    },
    data() {
        return {
            tipinput: '',
            position: false,
            visible: false,
            prefix: '',
            loading: false,
            city: [],
            area: [],
            district: [],
            province: '',
            changeFlag: false,
            form: {
                name: '',
                code: '',
                id: '',
                phone: '',
                provinceId: '',
                cityId: '',
                districtId: '',
                address: '',
                latitude: '',
                longitude: '',
                email: '',
                weight: '',
                trial: '',
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.Storename_not_empty'),
                        trigger: 'blur',
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.phone_not_empty'),
                        trigger: 'blur',
                    },
                ],
                provinceId: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.Provinces_not_empty'),
                        trigger: 'blur',
                    },
                ],
                cityId: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.city_not_empty'),
                        trigger: 'blur',
                    },
                ],
                districtId: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.place_not_empty'),
                        trigger: 'blur',
                    },
                ],
                address: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.add_not_empty'),
                        trigger: 'blur',
                    },
                ],
                latitude: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.Latitude_not_empty'),
                        trigger: 'blur',
                    },
                ],
                logitude: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.longitude_not_empty'),
                        trigger: 'blur',
                    },
                ],
                email: [
                    {
                        required: true,
                        type: 'string',
                        message: this.$t('Store.Edit.email_not_empty'),
                        trigger: 'blur',
                    },
                ],
                weight: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.Sortweight_not_empty'),
                        trigger: 'blur',
                    },
                    {
                        type: 'number',
                        message: this.$t('Store.Edit.Sortweight_number'),
                        trigger: 'blur',
                    },
                ],
                trial: [
                    {
                        required: true,
                        message: this.$t('Store.Edit.trialoperations'),
                        trigger: 'blur',
                    },
                ],
            },
            map: null,
            result: {},
        };
    },
    created() {
        if (this.$route.params.id) this.fetchData();
        else this.fetchDistrict();
    },
    watch: {},
    computed: {},
    mounted() {},
    methods: {
        fetchData() {
            this.loading = true;
            API.get(`store/${this.$route.params.id}`)
                .then(res => {
                    this.form = res;
                    this.fetchDistrict();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.$route.params.id) this.putData();
                    else this.postData();
                }
            });
        },
        postData() {
            this.loading = true;
            API.post('store/', this.form)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                    this.$router.back();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        putData() {
            this.loading = true;
            API.put(`store/${this.$route.params.id}`, this.form)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                    this.$router.back();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleProvinceChange(val) {
            if (this.changeFlag) {
                this.form.cityId = '';
                this.form.districtId = '';
            }
            if (this.district) {
                this.district.forEach(el => {
                    if (el.id === val.toString()) {
                        this.province = el;
                    }
                    return el;
                });
            }
            this.handleCityChange(this.form.cityId);
        },
        handleCityChange(val) {
            if (this.changeFlag) {
                this.form.districtId = '';
            }
            if (this.province && this.province.children) {
                this.province.children.forEach(el => {
                    if (el.id === val.toString()) {
                        this.city = el;
                    }
                });
                this.changeFlag = true;
            }
        },
        fetchDistrict() {
            this.loading = true;
            API.get('district')
                .then(res => {
                    this.district = res;
                    this.initMap(
                        this.form.longitude ? this.form.longitude : '113.31962585',
                        this.form.latitude ? this.form.latitude : '23.1245327'
                    );
                    this.handleProvinceChange(this.form.provinceId);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        EditContract(row) {
            this.$router.push({
                name: 'Store.Contract',
                params: { id: row.id },
            });
        },
        back() {
            this.$router.back();
        },
        initMap(longitude, latitude) {
            this.map = new AMap.Map('container', {
                zoom: 13, // 级别
                resizeEnable: true,
                center: [longitude, latitude], // 中心点坐标
                viewMode: '3D', // 使用3D视图
            });
            return this.map;
        },
        placeSearch() {
            this.position = true;
        },
        flushPosition(data) {
            this.form.latitude = data.location.lat;
            this.form.longitude = data.location.lng;
        },
        keyUpSearch(e) {
            const map = this.map;
            AMap.plugin(
                ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.ToolBar'],
                () => {
                    var toolbar = new AMap.ToolBar();
                    map.addControl(toolbar);
                }
            );
            let autoOptions = {
                // 使用联想输入的input的id
                input: 'tipinput',
            };
            let autocomplete = new AMap.Autocomplete(autoOptions);
            let placeSearch = new AMap.PlaceSearch({
                map: map,
            });
            AMap.event.addListener(autocomplete, 'select', e => {
                placeSearch.search(e.poi.name);
                this.result = e.poi;
                if (e.poi) this.flushPosition(e.poi);
            });
        },
    },
};
</script>
<style lang="scss">
.fitness-store-edit {
  min-width: 1200px;
  #container {
    position: relative;
    left: 9%;
    min-width: 50%;
    min-height: 40%;
    margin: 20px 0px;
  }
  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 200px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 200px;
  }
  .el-select {
    width: 200px;
  }
  .el-input {
    width: 200px;
  }
  .el-form-item {
    padding-right: 20px;
  }
  .position-div {
    position: relative;
    left: 200px;
    top: -354px;
    z-index: 10;
  }
  .position-input {
    width: 300px;
    height: 30px;
    font-size: 14px;
    border-radius: 4px;
  }
}
</style>
